import { Loader, useAuthStoreSelectors, useFiles } from "@/shared";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { match } from "ts-pattern";
import { ClientFilesList } from "./components";

export const ClientFilesPage = () => {
  const client_id = useAuthStoreSelectors.use.user_id() || "";

  const { clientFiles, getFiles, isPending, error } = useFiles();

  useEffect(() => {
    getFiles({ client_id });
  }, [client_id]);

  return (
    <Box width="100%" height="100%">
      {match({ isPending })
        .with({ isPending: true }, () => <Loader />)
        .otherwise(() => (
          <ClientFilesList clientFiles={clientFiles} error={error} />
        ))}
    </Box>
  );
};
